import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../styles/AdminOrders.css";

const STATUS_OPTIONS = [
  "ALL",
  "PENDING",
  "PAID",
  "PROCESSING",
  "SHIPPED",
  "DELIVERED",
  "CANCELLED",
];

export default function AdminOrders() {
  const { t } = useTranslation();
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");
  const navigate = useNavigate();

  useEffect(() => {
    loadOrders();
  }, []);

  const loadOrders = async () => {
    const response = await fetch("/api/admin/orders", {
      credentials: "include",
    });

    if (response.ok) {
      setOrders(await response.json());
    }
  };

  const filteredOrders = orders.filter((order) => {
    const searchText = search.toLowerCase();

    const matchesSearch =
      order.orderNumber?.toLowerCase().includes(searchText) ||
      order.customerName?.toLowerCase().includes(searchText) ||
      order.customerEmail?.toLowerCase().includes(searchText);

    const matchesStatus =
      statusFilter === "ALL" || order.status === statusFilter;

    return matchesSearch && matchesStatus;
  });

  return (
    <main className="admin-orders-page">
      <section className="admin-orders-container">
        <button
          className="admin-orders-back"
          onClick={() => navigate("/admin")}
        >
          ← {t("adminOrders.backToDashboard")}
        </button>

        <h1>{t("adminOrders.title")}</h1>

        <div className="admin-orders-filters">
          <input
            type="text"
            value={search}
            placeholder={t("adminOrders.searchPlaceholder")}
            onChange={(e) => setSearch(e.target.value)}
          />

          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            {STATUS_OPTIONS.map((status) => (
              <option key={status} value={status}>
                {status === "ALL"
                  ? t("adminOrders.allStatuses")
                  : t(`orders.status.${status}`)}
              </option>
            ))}
          </select>
        </div>

        <div className="admin-orders-table">
          <div className="admin-orders-header">
            <span>{t("adminOrders.order")}</span>
            <span>{t("adminOrders.customer")}</span>
            <span>{t("adminOrders.date")}</span>
            <span>{t("adminOrders.paymentMethod")}</span>
            <span>{t("adminOrders.status")}</span>
            <span>{t("adminOrders.total")}</span>
            <span></span>
          </div>

          {filteredOrders.length === 0 ? (
            <div className="admin-orders-empty">
              {t("adminOrders.noOrdersFound")}
            </div>
          ) : (
            filteredOrders.map((order) => (
              <article className="admin-orders-row" key={order.id}>
                <span>{order.orderNumber}</span>

                <span>
                  {order.customerName}
                  <small>{order.customerEmail}</small>
                </span>

                <span>{new Date(order.createdAt).toLocaleDateString()}</span>

                <span>
                  {t(`orders.paymentMethods.${order.paymentMethod}`)}
                </span>

                <span className={`admin-order-status ${order.status.toLowerCase()}`}>
                  {t(`orders.status.${order.status}`)}
                </span>

                <strong>{Number(order.total).toFixed(2)} €</strong>

                <button onClick={() => navigate(`/admin/orders/${order.id}`)}>
                  {t("adminOrders.viewDetail")}
                </button>
              </article>
            ))
          )}
        </div>
      </section>
    </main>
  );
}